import script from "./ServiceCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCreateView.vue?vue&type=script&setup=true&lang=js"

import "./ServiceCreateView.vue?vue&type=style&index=0&id=31b6da22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31b6da22"]])

export default __exports__